import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { ComplianceTypeEntity } from "../../entities/ComplianceTypeEntity";

export class GetComplianceTypesUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(): Promise<ComplianceTypeEntity[]> {
    return await this.repository.getComplianceTypes();
  }
}

